// Mirrors the backend ServiceProviderRoles [Flags] enum
// None=0, Assistant=1, Autonomous=2, ProxyDataEntry=4, Approver=8, DelegatedAdmin=16, ExecutiveAdmin=32
export function bitsToRoleAssignments(roles: number | undefined) {
  const bits = roles ?? 0;
  return {
    isAssistant: (bits & 1) !== 0,
    isAutonomous: (bits & 2) !== 0,
    isProxyDataEntry: (bits & 4) !== 0,
    isApprover: (bits & 8) !== 0,
    isDelegatedAdmin: (bits & 16) !== 0,
    isExecutiveAdmin: (bits & 32) !== 0,
  };
}
